import { render, staticRenderFns } from "./ReportsInExcel.vue?vue&type=template&id=56e02475&"
import script from "./ReportsInExcel.vue?vue&type=script&lang=js&"
export * from "./ReportsInExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports